import Icon from '@/components/atoms/Icon'
import Modal from '@/components/atoms/Modal'
import profileService from '@/services/profileService'
import { useAppSelector } from '@/store/hooks'
import { Dialog } from '@headlessui/react'

interface SkillMappingProps {
	disabledOnClose?: boolean
}

export function SkillMapping({ disabledOnClose }: SkillMappingProps) {
	const {
		modal: { modalInfo },
	} = useAppSelector((state) => state)

	const { execute: editProfile } = profileService.editMutation()

	const handleCloseModal = async () => {
		await editProfile({ show_modal_skill_mapping: false })
	}

	return (
		<Modal
			name='skillMappingModal'
			disabledOnClose={disabledOnClose}
			className='relative py-12 md:px-12 md:py-20 md:pb-24 max-w-[700px] overflow-clip dark:bg-modal-new-journey rounded-2xl'
			onClose={handleCloseModal}
		>
			<div className='absolute -top-2 sm:-top-5 left-0 right-0 z-0'>
				<img
					src={`/imgs/admin/modals/title-journey.png`}
					width='100%'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>

			<div className='absolute top-0 left-0'>
				<img
					src={`/imgs/admin/modals/journey-top-left.png`}
					width='293px'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>
			<div className='flex flex-col items-center gap-8 md:gap-12'>
				<div className='flex flex-col gap-7 items-center'>
					<Icon
						name='journey'
						className='text-white'
						width='194px'
						height='71px'
					/>
					<div className='flex flex-col items-center gap-6'>
						<div className='relative'>
							<Dialog.Title
								as='h3'
								className='relative text-3xl md:text-4xl font-bold leading-[120%] text-[#FBFAFE] z-10'
							>
								🚀 Vamos dar o primeiro passo?
							</Dialog.Title>
							<span className='absolute -top-32 -right-32 md:-right-6 z-0 opacity-30'>
								<img
									src={`/imgs/admin/modals/new-journey-title.png`}
									width='325px'
									height='auto'
									alt='Imagem de spray no modal whatsapp'
									className='w-[305px] md:w-[325px]'
								/>
							</span>
						</div>
						<div className='flex flex-col gap-3 z-10 justify-center items-center'>
							<p className='w-full text-lg md:text-xl lg:text-2xl font-medium text-white/80 leading-[130%] md:leading-[150%] max-w-[550px]'>
								Antes de começar sua jornada, é essencial realizar o seu
								mapeamento de habilidades.
							</p>
							<p className='w-full text-lg md:text-xl lg:text-2xl font-medium text-white/80 leading-[130%] md:leading-[150%] max-w-[470px]'>
								👉{' '}
								<a
									href={modalInfo?.link_skill_mapping}
									target='_blank'
									rel='noopener noreferrer'
									className='underline font-bold underline-offset-4'
								>
									Clique aqui para responder agora
								</a>
								, é rápido e faz toda a diferença!
							</p>
						</div>
					</div>
				</div>
			</div>

			<div className='absolute -bottom-2 sm:-bottom-6 left-0 right-0 z-0'>
				<img
					src={`/imgs/admin/modals/title-journey.png`}
					width='100%'
					height='auto'
					alt='Imagem de spray no modal whatsapp'
				/>
			</div>
		</Modal>
	)
}
